import React, { useState } from "react"
import { InputBlock } from '../../../../generics/input-block'
import { useModal } from '../../../../../hooks/ModalContext'
import { UsuarioAtualizar } from "../../../../../types/supervisao/usuario-interface";
import { useUsuario } from "../../../../../context/Suporte/CadastroUsuarioContext";

interface HandleChangeProps {
  event?: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  name?: string;
  value?: string;
}


export const AtualizaUsuario = () => {
  const { infoUsuario, onClose } = useModal()
  const { atualizarCadastro } = useUsuario()

  const [usuario, setUsuario] = useState<UsuarioAtualizar>({} as UsuarioAtualizar)

  function handleChange({ event, name }: HandleChangeProps) {
    if (event && !name) {
      const { name, value } = event.target;

      let nome = name === 'Nome Completo' ? 'name' : name === 'Usuário Discador' ? 'usuarioDiscador' : name === 'Senha Discador' ? 'senhaDiscador' : name === 'Token/Url Discador' ? 'urlDiscador' : name === 'Senha' ? 'password' : name.toLocaleLowerCase()
      setUsuario(prevState => ({
        ...prevState,
        [nome]: value,
      }));
      return
    }
  }

  async function handleAtualizarUsuario() {
    const usuarioAtualizar: UsuarioAtualizar = {
      name: usuario?.name || infoUsuario.name,
      login: usuario?.login || infoUsuario.login,
      email: usuario?.email || infoUsuario.email,
      urlDiscador: usuario?.urlDiscador || infoUsuario.urlDiscador,
      usuarioDiscador: usuario?.usuarioDiscador || infoUsuario.usuarioDiscador,
      senhaDiscador: usuario?.senhaDiscador || infoUsuario.senhaDiscador,
      cpf_cnpj: infoUsuario.cpf_cnpj
    }
    await atualizarCadastro(usuarioAtualizar)
    onClose()
  }


  return (
    <>
      <div>
        <h2 className="text-primary w-full text-center font-semibold text-lg">Atualizar usuário</h2>

        <div>
          <div className="my-2 flex w-full items-center gap-2">
            <InputBlock name="Nome Completo" placeholder={infoUsuario.name} onChange={e => { handleChange({ event: e }) }} value={usuario?.name} />

          </div>
          <div className="my-2 flex w-full items-center gap-2">
            <InputBlock name="Login" placeholder={infoUsuario.login} onChange={e => { handleChange({ event: e }) }} value={usuario?.login} />
            <InputBlock name="Email" placeholder={infoUsuario.email} onChange={e => { handleChange({ event: e }) }} value={usuario?.email} />
          </div>

          <div className="my-2 flex w-full items-center gap-2">
            <div className="mt-2 w-full"><InputBlock name="Usuário Discador" placeholder={infoUsuario.usuarioDiscador} onChange={e => { handleChange({ event: e }) }} value={usuario.usuarioDiscador} /></div>

            <div className="mt-2 w-full"><InputBlock name="Senha Discador" placeholder={infoUsuario.senhaDiscador} onChange={e => { handleChange({ event: e }) }} value={usuario.senhaDiscador} /></div>
          </div>


          <div className="mt-2 mb-12"><InputBlock name="Token/Url Discador" placeholder={infoUsuario.urlDiscador} onChange={e => { handleChange({ event: e }) }} value={usuario.urlDiscador} /></div>

        </div>

        <button className="bottom-6 right-5 absolute bg-primary rounded-md text-white p-2" onClick={() => handleAtualizarUsuario()}>Atualizar usuário</button>
      </div>
    </>
  )
}